import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { formatDate, toDate } from '../../../../helpers/formatDate.js';

const useStyles = makeStyles((theme) => ({
  custom_date_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'fit-content',
  },

  DateInput: {
    margin: '0 4px',
    width: '132px',
    '& .MuiInputBase-root': {
      maxWidth: '100%',
      fontSize: theme.fonts.responsiveMedium,
      padding: '6px',
    },
    '& .MuiInputBase-input': {
      padding: '0',
      fontSize: '12px',
    },
    '& .MuiInputAdornment-root': {
      padding: '0 4px',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
}));

const CustomDatePicker = ({ setDates, customDate, setCustomDate }) => {
  const classes = useStyles();

  const setCustomDateFrom = (newDateFrom) => {
    try {
      const next = [formatDate(newDateFrom, '00:00'), customDate[1]];
      setCustomDate(next);
      setDates(next);
    } catch {
      // ignore invalid picker values while typing
    }
  };

  const setCustomDateTo = (newDateTo) => {
    try {
      const next = [customDate[0], formatDate(newDateTo, '23:59')];
      setCustomDate(next);
      setDates(next);
    } catch {
      // ignore invalid picker values while typing
    }
  };

  return (
    <div className={classes.custom_date_container}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          className={classes.DateInput}
          key='from'
          value={toDate(customDate[0])}
          onChange={setCustomDateFrom}
          format='dd/MM/yyyy'
          id='date_from'
        />
        <KeyboardDatePicker
          className={classes.DateInput}
          key='to'
          value={toDate(customDate[1])}
          onChange={setCustomDateTo}
          format='dd/MM/yyyy'
          id='date_to'
        />
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default CustomDatePicker;
